import React from 'react';
import createReactClass from 'create-react-class';
import Widget from '../common/Widget';
import { Link } from 'react-router-dom';

var VendorPurchaseUnitList = createReactClass({
  onpurchaseUnits(vendor) {
    this.props.editUnits(vendor);
  },
  onVendorRemove(vendor) {
    this.props.removeVendor(vendor);
  },
  onpurchaseUnitRemove(vendor, unit) {
    this.props.removeUnit(vendor, unit);
  },
  handleCreateNewUnit(vendor) {
    this.props.history.push(`/items/${this.props.itemId}/vendors/${vendor.id}/units/new`);
  },

  render() {
    return (
      <div>
          {this._getVendorList()}
      </div>
    );
  },

  _getVendorList() {
    if(this.props.vendors.length === 0) {

      return (
        <div style={{display: 'flex'}}>
          <h2>
            <i className="fa fa-arrow-up" style={{marginLeft: 10, marginRight: 10}}></i>
            Bitte fügen Sie diesem Artikel oben einen Lieferanten hinzu.
          </h2>
        </div>
      );

    } else {
      return this.props.vendors.map(vendor =>
        <Widget key={vendor.id} title={vendor.vendorName} containerClassName="col-md-12" icon="paper-plane-o">
          {this._getVendor(vendor)}

          <div className="widget-footer">
              <input type="button" className="btn btn-primary" value="Neue Bestelleinheit" onClick={() => this.handleCreateNewUnit(vendor)}/>
              <input type="button" className="btn btn-danger" value="Artikellieferant löschen" onClick={() => this.onVendorRemove(vendor)}/>
          </div>
        </Widget>
      );
    }
  },

  _getVendor(vendor) {
    if(vendor.purchaseUnits.length === 0) {

      return (
        <div style={{display: 'flex', justifyContent: 'center'}}>
          <h2>Bitte fügen Sie diesem Lieferanten eine Bestelleinheiten hinzu.</h2>
        </div>
      );

    } else {

      var list = vendor.purchaseUnits.map(unit =>
        <tr key={unit.unitId}>
          <td><Link to={`/items/${this.props.itemId}/vendors/${vendor.id}/units/${unit.unitId}`}>{unit.name}</Link></td>
          <td><Link to={`/items/${this.props.itemId}/vendors/${vendor.id}/units/${unit.unitId}`}>{unit.stockUnitQuantity}</Link></td>
          <td><Link to={`/items/${this.props.itemId}/vendors/${vendor.id}/units/${unit.unitId}`}>{unit.externalId}</Link></td>
          <td><Link to={`/items/${this.props.itemId}/vendors/${vendor.id}/units/${unit.unitId}`}>{unit.netPrice}</Link></td>
          <td><Link to={`/items/${this.props.itemId}/vendors/${vendor.id}/units/${unit.unitId}`}>{unit.minPurchaseQuantity}</Link></td>
          <td>
            <a className="btn-sm btn-danger" onClick={() => this.onpurchaseUnitRemove(vendor, unit)}><i className="fa fa-remove"></i></a>
          </td>
        </tr>
      );

      return (
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th width="20%">Einheit</th>
                <th width="20%">Menge pro Einheit</th>
                <th width="20%">Lief. Artikel Nr.</th>
                <th width="20%">Nettopreis/Einheit</th>
                <th width="20%">Mindestbestellmenge</th>
                <th width="20%">Aktionen</th>
              </tr>
            </thead>
            <tbody>
              {list}
            </tbody>
          </table>
        </div>
      );
    }
  }

});

export default VendorPurchaseUnitList;



// WEBPACK FOOTER //
// ./src/components/purchaseunits/VendorPurchaseUnitList.js